"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const b = b_1.default.with('error-message');
const ErrorMessage = ({ message, size = 's' }) => {
    const fontSize = size === 's' ? 13 : 14;
    const styles = (0, react_1.css) `
        z-index: 1;

        position: absolute;

        left: 0;
        right: 0;
        bottom: 0;

        text-align: center;

        margin: 0;
        padding: 1em 2em;

        background: #e00000;
        color: #f6f5f3;

        font-size: ${fontSize}px;
        line-height: 24px;
        padding-top: calc(0.02 * var(--rem));
        padding-bottom: calc(0.02 * var(--rem));
        bottom: var(--app-paddingbtm);
    `;
    return message ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: styles, className: b() }, { children: message }))) : null;
};
exports.ErrorMessage = ErrorMessage;
